import { ChakraProvider } from "@chakra-ui/react";
import { ModuleRegistry } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
// import { ColorModeProvider } from "./components/ui/color-mode.tsx";
import { AG_GRID_ENTERPRISE_LICENSE_KEY } from "./configs/config.ts";
import "./index.css";
import { theme } from "./themes";

// import system from "./themes/index.js";

ModuleRegistry.registerModules([AllEnterpriseModule]);
LicenseManager.setLicenseKey(AG_GRID_ENTERPRISE_LICENSE_KEY);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ChakraProvider theme={theme}>
      {/* <ColorModeProvider> */}
      <App />
      {/* </ColorModeProvider> */}
    </ChakraProvider>
  </StrictMode>,
);
